module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-700-cae5027f600d2a0d88ac309655618e31.ttf";